import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-row" }
const _hoisted_2 = { class: "card flex-fill justify-self-stretch" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "card-footer text-center" }
const _hoisted_7 = {
  ref: "formClassroom",
  target: "_blank",
  method: "POST"
}
const _hoisted_8 = { class: "d-flex justify-content-around" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = {
  type: "submit",
  class: "d-none",
  ref: "btnSubmit"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "fas fa-spinner fa-spin fa-fw ms-2"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  tabindex: "0",
  class: "btn p-0",
  role: "button",
  "data-bs-toggle": "popover",
  "data-bs-html": "true",
  title: "Activación de Clases Grabadas",
  "data-bs-content": "<p>La activación de las clases grabadas toma entre <strong>30 y 60 minutos</strong>\n                    después de que su academia fue activada.</p>\n                    <p>En caso de que haya pasado más de ese tiempo favor de enviar un\n                    correo a soporte técnico: <a href='mailto:soporte@gtr.academy'>soporte@gtr.academy</a></p>",
  "data-bs-trigger": "focus",
  ref: "activando"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, [
        (_ctx.showLiveClasses)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fas fa-school me-2" }, null, -1),
              _createTextVNode("Clases en Vivo y Grabadas ", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("i", { class: "fas fa-video me-2" }, null, -1),
              _createTextVNode("Clases Grabadas ", -1)
            ]))]))
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-body d-flex align-items-center text-center" }, [
        _createElementVNode("div", { class: "" }, [
          _createElementVNode("p", null, " Aprende de nuestros traders profesionales desde lo más básico hasta técnicas avanzadas de trading en Forex, operaciones binarias y trading deportivo. Marketing y todo lo relacionado al mundo crypto. "),
          _createElementVNode("p", null, " Además conoce todas las estrategias de mercadeo en red para sacar el máximo provecho de tu suscripción. ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.showLiveClasses)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_router_link, {
                    to: "/academy",
                    class: "btn btn-secondary mx-4 lh-sm"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode(" Clases en Vivo ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("button", _hoisted_12, null, 512),
                  _createElementVNode("button", {
                    class: "btn btn-secondary lh-sm",
                    role: "button",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.classroomLogin()), ["prevent"])),
                    disabled: _ctx.gettingToken
                  }, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Clases Grabadas", -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-external-link-alt ms-2" }, null, -1)),
                    (_ctx.gettingToken)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_14))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_13)
                ]),
                _createElementVNode("button", {
                  class: "btn p-0",
                  "data-bs-toggle": "popover",
                  title: "Permitir Ventanas Emergentes",
                  "data-bs-content": "Para poder acceder a sus clases grabadas, debe permitir al navegador el abrir ventanas emergentes (Popups).",
                  "data-bs-trigger": "focus",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                  ref: "popups"
                }, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("i", { class: "fas fa-info-circle fa-fw" }, null, -1)
                ]))], 512)
              ])
            ], 512), [
              [_vShow, _ctx.isClassroomActive]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_15, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "flex-grow-1" }, [
                  _createElementVNode("button", {
                    class: "btn btn-secondary lh-sm",
                    role: "button",
                    disabled: ""
                  }, [
                    _createTextVNode(" Clases Grabadas"),
                    _createElementVNode("i", { class: "fas fa-cog fa-spin fa-fw ms-2" })
                  ])
                ], -1)),
                _createElementVNode("a", _hoisted_16, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("i", { class: "fas fa-info-circle fa-fw" }, null, -1)
                ]))], 512)
              ])
            ], 512), [
              [_vShow, !_ctx.isClassroomActive]
            ])
          ])
        ], 512)
      ])
    ])
  ]))
}